// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ago_users_header_box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0px;
  height: 50px;
  background-color: var(--bg-card);
  border-bottom: 1px solid var(--border);
  margin-bottom: 30px;
}

.ago_users_count_div{
  display: flex;
  align-items: center;
  background-color: var(--bg);
  color: var(--primary);
  padding: 3px 10px;
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/pages/ago/agoUsers.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gCAAgC;EAChC,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".ago_users_header_box{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 0px;\n  height: 50px;\n  background-color: var(--bg-card);\n  border-bottom: 1px solid var(--border);\n  margin-bottom: 30px;\n}\n\n.ago_users_count_div{\n  display: flex;\n  align-items: center;\n  background-color: var(--bg);\n  color: var(--primary);\n  padding: 3px 10px;\n  border-radius: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
